<template>
	<o-select
		v-if="setup.dataLoaded"
		v-model="setup.selectedTagIds"
		:label="$t('common.label.tag')"
		display-key="name"
		track-key="id"
		value-key="id"
		:searchable="setup.options.length > 10"
		:options="setup.options"
		v-bind="{ ...$attrs, multiple }">
		<template #value="{ item: tag }: { item: TagListItemEntity }">
			<template v-if="!multiple">
				<div
					v-if="tag"
					class="tag-option">
					<div
						class="tag-color"
						:class="`background--${tag.colorName}`"/>
					{{ tag.name }}
				</div>
			</template>
			<template v-else>
				<div
					v-if="tag && typeof tag === 'number'"
					class="tag-option">
					<div
						class="tag-color"
						:class="`background--${setup.getTagById(tag)?.colorName}`"/>
					{{ setup.getTagById(tag)?.name }}
				</div>
				<div
					v-else-if="tag"
					class="tag-option">
					<div
						class="tag-color"
						:class="`background--${tag.colorName}`"/>
					{{ tag.name }}
				</div>
			</template>
		</template>

		<template #option="{ item: tag }">
			<div class="tag-option">
				<div
					class="tag-color"
					:class="`background--${tag.colorName}`"/>
				{{ tag.name }}
			</div>
		</template>
	</o-select>
</template>

<script setup lang="ts">
// #region Setup
import type TagListItemEntity from '@/entity/TagListItemEntity';
import type { SharedTagSelectEmits, SharedTagSelectProps } from './SharedTagSelectSetup';
import SharedTagSelectSetup from './SharedTagSelectSetup';
const emits = defineEmits<SharedTagSelectEmits>() as SharedTagSelectEmits;
const props = withDefaults(defineProps<SharedTagSelectProps>(), SharedTagSelectSetup.defaultProps);
const setup = new SharedTagSelectSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
.tag-color {
	width: 1rem;
	height: 1rem;
	border-radius: 0.25rem;

	.orion-select__selected-item & {
		margin-left: calc((0.25rem) * -1);
	}
}

.tag-option {
	cursor: pointer;
	display: flex;
	gap: 0.5rem;
	align-items: center;

	.orion-select__selected-item & {
		gap: 0.25rem;
	}
}
</style>
